import { render, staticRenderFns } from "./search-filter.vue?vue&type=template&id=920b19c0"
import script from "./search-filter.vue?vue&type=script&lang=js"
export * from "./search-filter.vue?vue&type=script&lang=js"
import style0 from "./search-filter.vue?vue&type=style&index=0&id=920b19c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports